import ApiRequestManagerInstance from '../ApiRequestManager';
import { IPlanRequest, IPlanRequestData } from '../../types/interfaces/plan';
import { setOperator } from '../../store/slices/user.slice';
import { store } from '../../store/store';
import AnalyticsInstance from '@shared/utils/analytics';
import DeviceConfig from '@devices/config';

function planRequest() {
  const promise = new Promise<IPlanRequestData[]>(async (resolve, reject) => {
    try {
      const response: IPlanRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'cdnSyncUrl',
          section: 'media',
          subsection: 'carrier',
          type: 'plans',
        },
      })) as IPlanRequest;
      const omnitrackConfig = response?.data?.omnitrack;
      if (omnitrackConfig) {
        AnalyticsInstance.setConfig({
          active: omnitrackConfig?.active && omnitrackConfig?.platforms.includes(DeviceConfig.info.analyticsPlatform),
          frequency: omnitrackConfig?.analytics_frequency,
          pingFrequency: omnitrackConfig?.ping_frequency,
          inactivitySessionTime: omnitrackConfig?.inactivity_sesion_time || omnitrackConfig?.inactivity_session_time,
        });
      }
      store.dispatch(
        setOperator({
          cdnBalancer: response?.data?.cdnBalancer,
          code: response.data?.code,
          isP2P: response.data?.isP2P,
          landing: response.data?.landing,
          moreContentEnabled: response.data?.moreContentEnabled ?? false,
          mySpaceEnabled: response.data?.mySpaceEnabled ?? false,
          name: response.data?.name,
          serviceLogo: response.data?.serviceLogo,
        })
      );
      resolve(response.data?.plans);
    } catch (e) {
      reject({});
    }
  });

  return promise;
}

export default planRequest;
